import {
  put, all, call, select, takeEvery, fork,
} from 'redux-saga/effects';
import { delay } from 'redux-saga';
import chunk from 'lodash/chunk';
import { getCurrentAuthHeader } from 'domain/fuse/auth/utils';
import { exception } from 'circe/logger';
import { fetch as fetchApi } from './api';
import { fetch, fetchAll, fetched } from './actions';

function* doFetch({ payload }) {
  try {
    if (document.hidden) {
      return;
    }

    const { shipmentId } = payload;

    const state = yield select();

    const headers = yield call(getCurrentAuthHeader, state);

    const results = yield call(fetchApi, shipmentId, headers);

    if (!results) {
      throw new Error(`Failed to track shipment ${shipmentId}`);
    }

    yield put(fetched(results));
  } catch (e) {
    exception(e);
  }
}

function* doFetchAll({ payload }) {
  try {
    const { shipmentIds } = payload;

    const shipmentsChunk = chunk(shipmentIds, 5);

    const chunksLength = shipmentsChunk.length;
    let i = 0;

    while (i < chunksLength) {
      const x = 0;
      while (x < shipmentsChunk[i].length) {
        yield put(fetch(shipmentsChunk[i][x]));
        x++;
      }
      yield call(delay, 800);
      i++;
    }
  } catch (e) {
    exception(e);
  }
}

export default function* () {
  yield all([takeEvery(fetch().type, doFetch), takeEvery(fetchAll().type, doFetchAll)]);
}
